import { Injectable } from "@angular/core";
import { Store, StoreConfig } from "@datorama/akita";

export enum CitizenIntroductionSteps {
    Welcome = "welcome",
    Visit = "visit",
    Responsibility = "responsibility",
    SuppliersAndPayment = "suppliers-and-payment"
}

export interface CitizenIntroductionState {
    currentStep: CitizenIntroductionSteps;
}

const initialState: CitizenIntroductionState = {
    currentStep: CitizenIntroductionSteps.Welcome
};

@StoreConfig({ name: "citizen-introduction", resettable: true })
@Injectable()
export class CitizenIntroductionStore extends Store<CitizenIntroductionState> {
    constructor() {
        super(initialState);
    }
}
